var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRocketSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #ed7850;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M156.6,384.9l-30.9-30.9c-8.5-8.5-11.5-20.8-7.7-32.2,3-8.9,7-20.5,11.8-33.8H24c-8.6,0-16.6-4.6-20.9-12.1s-4.2-16.7.2-24.1l52.5-88.5c13-21.9,36.5-35.3,61.9-35.3h82.3c2.4-4,4.8-7.7,7.2-11.3C289.1-4.1,411.1-8.1,483.9,5.3c11.6,2.1,20.6,11.2,22.8,22.8,13.4,72.9,9.3,194.8-111.4,276.7-3.5,2.4-7.3,4.8-11.3,7.2v82.3c0,25.4-13.4,49-35.3,61.9l-88.5,52.5c-7.4,4.4-16.6,4.5-24.1.2s-12.1-12.2-12.1-20.9v-107.2c-14.1,4.9-26.4,8.9-35.7,11.9-11.2,3.6-23.4.5-31.8-7.8h.1ZM384,168c22.1,0,40-17.9,40-40s-17.9-40-40-40-40,17.9-40,40,17.9,40,40,40Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocketSolid);
export default __webpack_public_path__ + "static/media/rocket-solid.235178e63dec5897f4094d19e476c8e0.svg";
export { ForwardRef as ReactComponent };